import React from 'react';

import Loading from '@shared/components/loading/Loading';
import { OptionWrapper } from './option-wrapper';
import { Wrapper } from './sub-menu-wrapper.styles';

interface IOptionComponent {
    component: React.ComponentType;
    props: Object;
}

interface IOptions {
    index: Number;
    label: string;
    tooltip: string;
    type: string;
    value: string;
    checked: Boolean;
    isVisible: Boolean;
    isAdvancedMetric: Boolean;
}

interface ISubMenuWrapper {
    className: string;
    onClick: Function;
    optionComponent: IOptionComponent;
    options: IOptions[];
    isLoading: Boolean;
}

const defaultProps = {
    className: '',
    onClick: () => {},
    optionComponent: { component: OptionWrapper, props: {} },
    options: [],
    isLoading: false,
};

export const SubMenuWrapper = ({
    options,
    onClick,
    optionComponent,
    className,
    isLoading,
}: ISubMenuWrapper) => {
    const { props: optionProps, component: Option } = optionComponent;
    return (
        <Wrapper className={className}>
            {isLoading ? <Loading height={25} />
                : Object.values(options).map((option) => {
                    const { label, value } = option;
                    return (
                        <Option
                            key={option.value}
                            onClick={() => onClick(option)}
                            label={label}
                            value={value}
                            checked={option.checked}
                            isVisible={option.isVisible}
                            isAdvancedMetric={option.isAdvancedMetric}
                            {...option}
                            {...optionProps}
                        />
                    );
                })}
        </Wrapper>
    );
};

SubMenuWrapper.defaultProps = defaultProps;

export default SubMenuWrapper;
